var _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.378e-06 89.9901V294.99C-0.00131202 299.756 0.936261 304.475 2.75879 308.878C4.58132 313.282 7.25316 317.283 10.6221 320.654C13.991 324.025 17.9909 326.699 22.3933 328.524C26.7957 330.349 31.5144 331.289 36.28 331.29H228.79C233.558 331.291 238.279 330.353 242.685 328.53C247.09 326.706 251.093 324.033 254.465 320.662C257.836 317.291 260.511 313.289 262.336 308.884C264.161 304.479 265.1 299.758 265.1 294.99V36.3C265.1 31.5322 264.161 26.8111 262.336 22.4064C260.511 18.0016 257.836 13.9994 254.465 10.6285C251.093 7.25764 247.09 4.58403 242.685 2.76038C238.279 0.93672 233.558 -0.00131207 228.79 1.37743e-06H90.02L18.8401 71.15L1.378e-06 89.9901Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9901L18.8401 71.15L90.02 1.37743e-06H228.79C233.558 -0.00131207 238.279 0.93672 242.685 2.76038C247.09 4.58403 251.093 7.25764 254.465 10.6285C257.836 13.9994 260.511 18.0016 262.336 22.4064C264.161 26.8111 265.1 31.5322 265.1 36.3V120.66H0V89.9901Z",
    fill: "#B66B12"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9905L44.4302 99.8004C53.8598 101.747 63.6767 99.8691 71.7217 94.5789C79.7667 89.2886 85.381 81.0197 87.3301 71.5905L89.1802 61.4004C88.5954 64.2123 87.6615 66.9401 86.4001 69.5204C83.4294 75.6563 78.7899 80.831 73.0134 84.4514C67.237 88.0719 60.5575 89.9916 53.7402 89.9905H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9901H53.7402C60.5575 89.9912 67.237 88.0715 73.0134 84.451C78.7899 80.8306 83.4294 75.6559 86.4001 69.52C87.6615 66.9397 88.5954 64.2119 89.1802 61.4C89.7416 58.8687 90.0198 56.2829 90.01 53.6901V0L18.8401 71.15L0 89.9901Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3181 253.71L57.0781 220.47L90.3181 187.23L98.1982 195.11L72.8281 220.47L98.1982 245.84L90.3181 253.71Z",
    fill: "#B66B12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.768 298.27L166.898 290.39L192.258 265.03L166.898 239.67L174.768 231.79L208.008 265.03L174.768 298.27Z",
    fill: "#B66B12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.699 196.485L109.922 284.772L120.287 288.855L155.064 200.568L144.699 196.485Z",
    fill: "#B66B12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.2806cac3311e62170546fc5915a20ccc.svg";
export { ForwardRef as ReactComponent };